const searchField = document.getElementById('js-header__search--field'),
    searchForm = document.getElementById('js-header-search-form'),
    minimumSearchTermLength = 4,
    autosuggestResultsWrapper = document.getElementById('js-header-autosuggest__results'),
    template = document.getElementById('js-header-autosuggest-item-template'),
    autosuggestSpinner = document.getElementById('js-header-search-spinner');

let timeout = null;

if(searchField) searchField.addEventListener('input', function () {
    if (searchField.value.length >= minimumSearchTermLength) {
        clearAutoSuggestResults();
        showAutoSuggest();
        showSpinner();
        clearTimeout(timeout);
        timeout = setTimeout(runAutosuggest, 500);
    } else {
        if (searchField.value.length < 1) {
            autosuggestResultsWrapper.innerHTML = '';
            hideSpinner();
            hideAutoSuggest();
        }
    }

    function runAutosuggest() {
        let url = searchForm.dataset.suggest;
        url += "&tx_solr[queryString]=" + searchField.value;
        fetch(url)
            .then(function (response) {
                if (!response.status === 200) {
                    console.log('Could not fetch the autosuggest Data: ' + response.statusText);
                }
                return response.json();
            })
            .then(function (json) {
                renderAutosuggest(json.documents);
            });
    }

    function renderAutosuggest(elements) {
        if (Array.isArray(elements)) {
            for (let element of elements) {
                let renderedElement = template.content.firstElementChild.cloneNode(true);
                let renderedElementHtml = replacePlaceholders(renderedElement.outerHTML, element);
                autosuggestResultsWrapper.appendChild(renderedElement);
                renderedElement.outerHTML = renderedElementHtml;
            }
        }
        hideSpinner();
    }

    function replacePlaceholders(renderedElementHtml, element) {
        // get all matches like ((mustContainSomething))
        let matches = renderedElementHtml.matchAll('\\(\\((?!\\)\\))[^\\)]*\\)\\)');
        for (let match of matches) {
            let elementIndex = match[0].replace('((', '')
                .replace('))', '');
            if (element[elementIndex] !== undefined) {
                renderedElementHtml = renderedElementHtml.replace(match[0], element[elementIndex]);
                continue;
            }
            console.log('Attribute does not exist in solr document: ' + elementIndex);
            renderedElementHtml = renderedElementHtml.replace(match[0], '');
        }
        return renderedElementHtml;
    }

    function showAutoSuggest() {
        searchForm.classList.add('js-show-autosuggest');
    }

    function hideAutoSuggest() {
        searchForm.classList.remove('js-show-autosuggest');
    }

    function clearAutoSuggestResults() {
        autosuggestResultsWrapper.innerHTML = '';
    }

    function showSpinner() {
        autosuggestSpinner.classList.add('js-show');
    }

    function hideSpinner() {
        autosuggestSpinner.classList.remove('js-show');
    }
});